<app-base-modal
  [title]="websiteLinksResourceType.name"
  [showStateToggle]="isValid()"
>
  <div class="content">
    @for (websiteLink of websiteLinksData(); track $index) {
      <div
        class="row"
        app-website-link-form
        [websiteLinkData]="websiteLink"
        [websiteLinkFormGroup]="websiteLinkFormGroups()[$index]"
        [parentId]="websiteLinksDialogData.parentId"
        [isEditModeActive]="isEditModeActive"
        [columnKey]="websiteLinksDialogData.modalKey"
        [noFirstData]="noFirstData()"
        (updateWebsiteLink)="updateWebsiteLinkData($event, $index)"
        (deleteWebsiteLink)="deleteWebsiteLinkData($index)"
      ></div>
    }
  </div>
  <div class="row-bottom">
    <button
      mat-mini-fab
      class="row-btn-add"
      [disabled]="!isValid"
      (click)="handleAddNew()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</app-base-modal>
